module.exports = __webpack_public_path__ + "static/media/cq_oggi b.c1eddfc5.svg";